import {Component} from '@angular/core';
import {Router} from "@angular/router";

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
})
export class AdminComponent {
  protected adminEntries: AdminEntry[];
  protected superAdminEntries: AdminEntry[];

  constructor(router: Router) {

    const allChildren = router.config
      .find(x => x.path == 'admin')
      .children
      .map(route => {
        const data = <AdminData>route.data
        return ({
          name: data.name,
          link: route.path,
          super: data.super
        });
      });
    this.adminEntries = allChildren.filter(entry => !entry.super)
    this.superAdminEntries = allChildren.filter(entry => entry.super)
  }
}

export class AdminEntry {
  name: string
  link: string
}

export class AdminData {
  name: string
  super: boolean
}
